import { render } from "./uv_index.vue?vue&type=template&id=3fad1053"
import script from "./uv_index.vue?vue&type=script&lang=js"
export * from "./uv_index.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__